import { Input } from "components/inputs";
import { Heading } from "iparque-components";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const StyledHeading = styled(Heading)`
  line-height: 1.2em;
`;

export const InputRow = styled.div`
  display: flex;
  margin-top: 10px;

  @media (max-width: ${breakpoints.md}) {
    flex-direction: column;
  }
`;

export const StyledInput = styled(Input)`
  box-sizing: border-box;
`;

export const CheckboxContainer = styled.div`
  @media (max-width: ${breakpoints.md}) {
    margin-top: 20px;
  }
`;

export const FormFields = styled.div`
  display: flex;
  margin-top: 20px;
  width: 90%;
  gap: 16px;
`;
